import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ComputerIcon from '@material-ui/icons/Computer';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
    backgroundColor: '#213759',
    color: '#ffffff',
    textAlign: 'center',
    padding: '2rem',
  },
  icon: {
    fontSize: 80,
    marginBottom: '1.5rem',
    opacity: 0.9,
  },
  subtitle: {
    maxWidth: 400,
    opacity: 0.8,
    marginTop: '1rem',
  },
}));

export const MobileBlockScreen = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <ComputerIcon className={classes.icon} />
      <Typography variant="h5" gutterBottom>
        Accès réservé aux ordinateurs
      </Typography>
      <Typography variant="body1" className={classes.subtitle}>
        Le tableau de bord Prof Express nécessite un écran d'ordinateur pour
        garantir la qualité de service. Veuillez vous connecter depuis un PC ou
        un Mac.
      </Typography>
    </Box>
  );
};
